import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { useSendSocialOfferContext } from "../logics/context";

export const Header = () => {
  const handleClose = useSendSocialOfferContext("handleClose");

  return (
    <DialogTitle component={Stack} direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h4" noWrap>
        Envoi d'une offre de service au candidat
      </Typography>
      <IconButton size="small" onClick={handleClose}>
        <CloseIcon fontSize="medium" color="primary" />
      </IconButton>
    </DialogTitle>
  );
};
